'use strict';

// https://stackoverflow.com/a/22082397
const IE11 = !!window.MSInputMethodContext && !!document.documentMode;

const { getDependencyClass } = require('../../lib/dependencies.js');
const performanceMeasure = require('../../lib/performanceMeasure.js');
let measure = performanceMeasure('webcomponents:iconFallback');

getDependencyClass('phoenix-page').then((pageClass) => {
    /**
     * PhoenixSvg
     *
     * A webcomponent to load inline SVG on IE11.
     *
     * @example
     * <phoenix-icon-fallback icon='icon_name'>
     *      <svg>
     *          <use xlink:href="/assets-global/icons/svg-sprite.svg?v=appCacheBuster#icon_name" />
     *      </svg>
     * </phoenix-icon-fallback>
     */
    class PhoenixIconFallback extends pageClass.PhoenixElement {
        connectedCallback() {
            if (!IE11) {
                return;
            }

            this.icon = this.getAttr('icon', {
                required: true,
            });

            fetch(`/assets-global/icons/${this.icon}.svg`).then((response) => {
                if (response.status !== 200) {
                    return;
                }

                response.text().then((svg) => {
                    if (svg) {
                        this.innerHTML = svg;
                    }
                });
            });
        }
    }
    window.customElements.define('phoenix-icon-fallback', PhoenixIconFallback);
    measure.end();
});
